import React from 'react';
import { connect } from 'react-redux';
import { translate } from 'react-i18next';
import { Button, Modal } from 'react-bootstrap';
import HeatToElectricalEnergyDetail from '../../components/renewable_energy/HeatToElectricalEnergyDetail';
import { createHeatToElectricalEnergy } from '../../redux/renewable_energy/heat_to_electrical_energy_actions';

class HeatToElectricalEnergyCreateModal extends React.Component {
  constructor(props) {
    super(props);
    this.heatToElectricalEnergyDetail = undefined;
    this.state = {
      isValid: false,
      isDirty: false,
      isSubmittable: false,
    };
  }

  onSaveHandler() {
    const newRenewableEnergy = this.heatToElectricalEnergyDetail.getWrappedInstance().getRenewableEnergyData();
    this.props.createRenewableEnergy(newRenewableEnergy);
  }

  render() {
    const { isCreating, errorMessage, t, ...newProps } = this.props;
    const { isSubmittable } = this.state;

    return (
      <Modal
        {...newProps}
        bsSize="large"
        aria-labelledby="contained-modal-title-lg"
        backdrop="static"
      >
        <Modal.Header closeButton>
          <Modal.Title id="contained-modal-title-lg">
            {t('create heat to electrical energy')}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <HeatToElectricalEnergyDetail
            ref={ref => (this.heatToElectricalEnergyDetail = ref)}
            onValid={isValid => this.setState({ isValid })}
            onDirty={isDirty => this.setState({ isDirty })}
            onSubmittable={isSubmittable => this.setState({ isSubmittable })}
            fieldErrors={errorMessage}
            onSubmit={() => !this.props.isCreating && !this.props.isCreated && this.onSaveHandler()}
          />
        </Modal.Body>
        <Modal.Footer>
          <Button
            id="renewable-energy-submit-create"
            disabled={!isSubmittable || isCreating}
            onClick={() => this.onSaveHandler()}
          >
            {this.props.isCreating ? `${t('creating')}...` : t('create')}
          </Button>
        </Modal.Footer>
      </Modal>
    );
  }
}

const mapStateToProps = state => {
  const heatToElectricalEnergyState = state.renewableEnergy.heatToElectricalEnergy;
  return {
    errorMessage: heatToElectricalEnergyState.errorMessage,
    isCreating: heatToElectricalEnergyState.isCreating,
  };
};

const mapDispatchToProps = dispatch => ({
  createRenewableEnergy: heatToElectricalEnergy =>
    dispatch(
      createHeatToElectricalEnergy(
        heatToElectricalEnergy.name,
        heatToElectricalEnergy.entropy,
        heatToElectricalEnergy.volume,
        heatToElectricalEnergy.description || '',
        heatToElectricalEnergy.image,
      ),
    ),
});

export default translate('translations')(
  connect(
    mapStateToProps,
    mapDispatchToProps,
  )(HeatToElectricalEnergyCreateModal),
);



// WEBPACK FOOTER //
// ./src/modal/renewable_energy/HeatToElectricalEnergyCreateModal.js